$('li.cursa span').on('click', function() {
  $(this).parent().children('ul').toggle();
});
